// Export without redux connection
import CameraPage from "./CameraPage";

export default CameraPage;
